import { render, staticRenderFns } from "./OwnerSummary.vue?vue&type=template&id=5df3f21c&"
import script from "./OwnerSummary.vue?vue&type=script&lang=js&"
export * from "./OwnerSummary.vue?vue&type=script&lang=js&"
import style0 from "./OwnerSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports